import RichText from '@/components/ui/RichText'
import { useLanguage } from '@/context/LanguageContext'
import { Row } from '@/services/cms-api/service-menu/types'
import { resolveImageUrl } from '@/utils/constants'
import { isNil } from '@/utils/validations'
import classNames from 'classnames'
import Image from 'next/image'
import { FunctionComponent } from 'react'

interface Prop {
  content: Row
  idx: number
}

const RowServiceContentRenderer: FunctionComponent<Prop> = ({ content, idx }) => {
  const { locale } = useLanguage()

    if (!content) return null

    const hasImages = !isNil(content.imageEn?.[0]?.url) && !isNil(content.imageMn?.[0]?.url)
    const hasHeaders = !isNil(content.headerEn) && !isNil(content.headerMn)
    const hasBodies = content.bodyEn !== null && content.bodyMn !== null

    const imageUrl = resolveImageUrl((locale === 'en' ? content.imageEn?.[0]?.url : content.imageMn?.[0]?.url))
    const localized = (enValue: any, mnValue: any) => (locale === 'en' ? enValue : mnValue)

    return (
      <div className='w-full flex flex-col'>
          <div
              className={classNames(
                  'pt-4 w-[95%] flex flex-col text-sm gap-4 md:gap-8 xl:items-center md:items-center justify-center md:text-base',
                  idx % 2 === 0 ? 'md:flex-col' : 'md:flex-col'
                )}
            >
              {hasImages && (
                  <Image
                      draggable={false}
                      alt={localized(content.headerEn, content.headerMn) || 'image'}
                      width={1000}
                      height={1000}
                      className={classNames(hasBodies ? 'md:w-2/5 rounded-xl' : 'w-full')}
                      src={imageUrl}
                    />
                )}
              <div className='flex flex-col justify-center items-center'>
                  {hasHeaders && (
                      <div className='flex flex-col'>
                          <h1 className='lg:text-4xl text-xl text-textHigh text-center font-semibold'>
                              {localized(content.headerEn, content.headerMn)}
                            </h1>
                        </div>
                    )}
                  {hasBodies && (
                      <div className='text-justify mt-5'>
                          <RichText content={localized(content.bodyEn, content.bodyMn)} />
                        </div>
                    )}
                </div>
            </div>
        </div>
  )
};

export default RowServiceContentRenderer
